<template>
	<div class="page" id="news-mobile">
		<h3 class="titles">
			次のステップで新聞を作ってみよう
		</h3>
		<ul class="news-mobile-step">
			<li>
				１　テーマを決めよう。〇〇新聞（題字）の部分にテーマを書こう。<br/>
				２　テーマに沿って取材をし、記事の材料を集めよう。<br/>
				３　取材のなかで、写真を撮影。いろんな写真をたくさん撮ってみよう。<br/>
				４　いちばん大事な「結論」を最初にリード文に書こう。<br/>
				５　本文記事（最大624文字）で説明を加えていこう。<br/>
				６　写真を選んでアップしよう。絵解き（写真の説明文）も忘れずに。<br/>
				７　主見出し、そで見出しをつけよう。<br/>
				８　全体を見直して、誤字脱字がないか、間違いがないかチェック。<br/>
				９　完成！ダウンロードして、みんなで共有してみよう。<br/>
			</li>
		</ul>
		<FormMobile ref="handle"/>

		<section class="btn-section">
			<a class="btn-section-red btn-preview"
				 @click="handleSubmit()">
				<img src="../../assets/img/loader.gif" class="loader" v-if="isLoading"/>
				作った新聞を確認
			</a>

			<router-link class="btn-section-blue" to="/introduction">
				トップに戻る
			</router-link>
		</section>
	</div>
</template>

<script>
	// Components
	import FormMobile from '../../components/newspaper/FormMobile'

	// Models
	import NewspaperModel from '../../models/newspaper.model'

	export default {
		name: 'NewspaperMobile',

		beforeRouteEnter (to, from, next) {
			const data = NewspaperModel.query().find(1)
			if (!data) NewspaperModel.insert({ data: NewspaperModel.defaultValue })

			next()
		},

		data () {
			return {
				screenSize: 0,
				errors: [],
				isLoading: false
			}
		},

		components: {
			FormMobile
		},

		computed: {
			item () {
				return NewspaperModel.query().find(1)
			}
		},

		methods: {
			/**
			 * Submit to Preview
			 */
			handleSubmit () {
			  this.isLoading = true

				const elements = this.$el.querySelectorAll('.input-contenteditable')

				// set data to model
				_.forEach(elements, (value) => {
					const field = value.getAttribute('field-name')

					this.item[field] = value.innerHTML
				})

				this.item.$save()

				return this.$refs.handle.handleCropImg().then(() => {
            // this.isLoading = false
					setTimeout(()=>{
              this.$router.push({ name: 'NewspaperPreview' })
					},3000)

				})
			},

			/**
			 * alert errors
			 * @return {number}
			 */
			validate () {
				let errors = []
				_.forEach(this.item, (value, key) => {
					if (value === '') {
						errors.push(key)
					}
				})

				this.errors = _.uniq(errors)

				return this.errors.length
			}
		}
	}
</script>

<style scoped lang="scss">
	.btn-blue {
		background-color: #1C7CD5;
	}

	.btn {
		a {
			width: 300px;
			cursor: pointer;
		}
	}
</style>
